import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import React from "react";

export default function PetsViewTile({consumerData, handleBooleans}) {
    return (
        <>
            <Typography variant="h5" component="h2">
                Pets (Optional)
            </Typography>
            <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
                <Grid item xs={12} sm={6} md={4}>
                    Is any business or farming conducted on site? (e.g. boarding of animals, carpentry, hair salon,
                    mechanic, daycare, etc.)<br/>
                    <b>{handleBooleans(consumerData?.isBusinessLocation)}</b>
                </Grid>
                {
                    consumerData?.isBusinessLocation &&
                    <Grid item xs={12} sm={6} md={4}>
                        What is the description of Business?<br/>
                        <b>{consumerData?.businessType}</b>
                    </Grid>
                }
                <Grid item xs={12} sm={6} md={4}>
                    Do you own any exotic animals?<br/>
                    <b>{handleBooleans(consumerData?.ownExoticAnimals)}</b>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    Do you own any dogs that are part of the following breed list: Akita, Alaskan
                    Malamute, American Staffordshire Terrier, Bullmastiff, Chow Chow, Doberman Pinscher,
                    German Shepherd, Great Dane, Pit Bull, Perro de Presa Canario, Rottweiler, Siberian
                    Husky, Staffordshire Bull Terrier, any wolf hybrid or any mix of these breeds?<br/>
                    <b>{handleBooleans(consumerData?.isDogBreedAmongListed)}</b>
                </Grid>
            </Grid>
        </>
    );
}
